export default "__VITE_ASSET__2f4b1608__"